(function () {
  'use strict';

  // Shopify theme-editor re-init guard.
  // Extend with custom observer logic if needed in future phases.
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('[id^="rf-cc-"]');
      if (!section) return;
      // Reset carousel scroll position so the editor shows from the start.
      var grid = section.querySelector('[id^="Slider-"]');
      if (grid) grid.scrollLeft = 0;
    });
  }
})();
